module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Black.3d308f6c.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/BasisGrotesquePro-Black.woff
// module id = 704
// module chunks = 168707334958949